<div [kalLoading]="loading"
     kalTheme="reverse"
     kalLoadingMessage="Connexion en cours">

    <app-user-delegation-picker [formControl]="delegationPickerFormControl"
                                isThemeReverse>
    </app-user-delegation-picker>

    <div class="gup-O-list gup-C-validationArea -right">
        <div class="gup-O-list__item">
            <kal-button kalTheme="primary"
                        [disabled]="delegationPickerFormControl.invalid"
                        (click)="saveDelegation()">
                Se connecter
            </kal-button>
        </div>
        <div class="gup-O-list__item">
            <kal-button kalTheme="reverse secondary"
                        (click)="logout()">
                Annuler
            </kal-button>
        </div>
    </div>

</div>
